export default [
  {
    path: '/legado',
    name: 'legado',
    component: () => import(/* webpackChunkName: "legado" */ './ListaLegado.vue')
  },
  {
    path: '/legado/:numeroProtocolo',
    name: 'legado',
    component: () => import(/* webpackChunkName: "legado" */ './Legado.vue')
  }
]
